module.exports = {"id":"206085","name":"Jacob Murphy","rating":"72","photo":"./data/images/photos/4/206085.png","club":{"name":"Newcastle Utd","logo":"./data/images/clubs/NewcastleUtd.png"},"positions":["MD","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JacobMurphy0.json
// module id = 1868
// module chunks = 0